/** Distância em linha reta na superfície da Terra (metros). */
export function haversineMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371000;
    const toRad = (d: number) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
}

export function formatDistanceMeters(m: number): string {
    if (!Number.isFinite(m) || m < 0) return '—';
    if (m < 1000) return `${Math.round(m)} m`;
    const km = m / 1000;
    const opts =
        km < 100
            ? { minimumFractionDigits: 1, maximumFractionDigits: 1 }
            : { maximumFractionDigits: 0 };
    return `${km.toLocaleString('pt-BR', opts)} km`;
}

export type GeoPoint = { lat: number; lng: number };

/**
 * Rótulo de distância: calcula com GPS do usuário; se não houver, usa fallback (ex. campo da API).
 */
export function distanceLabelFromCoords(
    user: GeoPoint | null | undefined,
    placeLat?: number | null,
    placeLng?: number | null,
    fallback?: string | null,
): string {
    if (
        user != null &&
        placeLat != null &&
        placeLng != null &&
        Number.isFinite(placeLat) &&
        Number.isFinite(placeLng)
    ) {
        return formatDistanceMeters(haversineMeters(user.lat, user.lng, placeLat, placeLng));
    }
    if (fallback != null && String(fallback).trim() !== '') return String(fallback);
    return '—';
}
